import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import blogReducer from "./blogReducer";
import propertiesReducer from "./propertiesReducer";
import loading_reducer from "./loading_reducer";
import errorBoundaryReducer from "./errorBoundaryReducer";
import globalErrorReducer from "./globalErrorReducer";
import editor_reducer from "./editor_reducer";

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  blog: blogReducer,
  properties: propertiesReducer,
  loading_reducer: loading_reducer,
  error_boundary: errorBoundaryReducer,
  global_error: globalErrorReducer,
  editor_reducer: editor_reducer,
});
